export default {
  main: {
    site_id: 18760127,
    title: "Terminal PRO",
    enableWorldCup: true,
    showBetBuilderSection: true,
    terminalId: 26737,
    unfocusForInactivity: false,
    disableCheckTicketAfterLogin: true,
    needAdminForResetPin: false,
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableTicketTimer: true,
    timeFormat: "HH:mm",
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    signInType: "email",
    enableHeaderAdminSection: true,
    enableDefaultHomeHeader: false,
    enableThemeToggle: true,
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    staffPassword: "0",
    websitePasswordHash: "33031858ccfd808828017abe3a4193a09e1542815ca885322cc04c2f22fe2244",
    logoSize: "extra-huge",
    termsAndConditions: false,
    enableGameInfo: true,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: true,
    enableSportListScroll: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    userSection: {
      sections: ["betHistory"],
    },

    historyTabConfig: [
      {
        icon: "sports-section",
        title: "Sport",
      },
      {
        icon: "terminal-deposit-success",
        title: "Withdrawal",
      },
    ],
    availableLanguages: {
      "@replace": true,
      spa: {
        short: "ES",
        name: "Esp",
        region: "UnitedKingdom",
        order: 2,
      },
      eng: {
        short: "EN",
        name: "Eng",
        region: "UnitedKingdom",
        order: 1,
      },
    },
  },
  betslip: {
    betDetailsOrder: ["total_odd", "stake_without_tax", "total_stake", "min_possible_win", "total_win"],
  },
  rfid: {
    logoutIfIdleSecondsCount: 0,
  },
  sportsbook: {
    enableBoostedOdds: true,
    enablePredefinedMultiples: true,
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: "betting/live",
      name: "Live",
      enabled: true,
    },
        {
      url: "betting/prematch/all",
      name: "Prematch",
      type: "sportsBook",
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
      ],
    },
    {
      url: "liveCasino",
      name: "Live Casino",
      disableByDefault: false,
      enabled: true,
    },
    {
      url: "betting/results",
      name: "Results",
      enabled: true,
    },
    {
      url: "thirdPartyGame/156147",
      name: "Pascal Gaming",
      enabled: true,
      iframeFullscreen: false,
      gameId: "156147",
      gameWithSecondScreen: false,
      onlyInHeader: false,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18760127, tid: 36537, token: " tJnBHQ==", currency: "COP" },
};
